import { useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useOnline } from '@/app/AppContext';

export function PwaUpdate({ editing }: { editing: boolean }) {
  const online = useOnline();
  const [error, setError] = useState('');
  const { needRefresh: [needRefresh], offlineReady: [offlineReady], updateServiceWorker } = useRegisterSW({
    onRegisterError() { setError('Offline app setup failed. Reopen while connected to retry.'); },
  });
  return <>
    {offlineReady && <p className="text-xs text-ink-300" role="status">Ready to open offline on this device.</p>}
    {needRefresh && <aside className="card p-4 space-y-2" aria-label="App update">
      <p>An app update is ready. Saved records will stay on this device.</p>
      <p className="text-xs text-ink-300">{editing ? 'Finish editing before updating.' : 'Update when you have finished entering records.'}</p>
      <button disabled={editing || !online} className="btn-ghost" onClick={() => { void updateServiceWorker(true).catch(() => setError('Could not update. Your current app is still available.')); }}>Update app</button>
    </aside>}
    {error && <p role="alert" className="text-warn text-sm">{error}</p>}
  </>;
}
